import { useTranslations } from 'next-intl';
import { z } from 'zod';
import { createFirstNameSchema, createLastNameSchema } from '../../form-controls/PersonName/schema';

function useNameEditFormSchema() {
  const t = useTranslations('form');

  return z.object({
    firstName: createFirstNameSchema(t),
    lastName: createLastNameSchema(t),
  });
}

type NameEditFormData = z.infer<ReturnType<typeof useNameEditFormSchema>>;

export { useNameEditFormSchema, type NameEditFormData };
